import type { AccountsConfig } from './type';

export const accounts: AccountsConfig = {
    formatAccountNumber: true,
    sendAccountNumberWithPut: true,
    preferredAccountNumberFormat: 'DBBAN',
    isJuniorAliasChangeAllowed: true,
    isNativeAliasChangeAllowed: true,
    accountDetailCopyActionAvailableForType: ['CURRENT', 'SAVING', 'LOAN'],
};
